import { Component } from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {AccountService} from "../account.service";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent {

  public isSubmitted : boolean = false;
  public getSplits: boolean = false;

  account = new FormGroup({
    description: new FormControl<string>('',Validators.required),
    personType: new FormControl<number>(0,Validators.required),
    company_cnpj: new FormControl<string>('',Validators.required),
    company_razaoSocial: new FormControl<string>('',Validators.required),
    company_email: new FormControl<string>('',Validators.required),
    company_phone : new FormControl<string>('',Validators.required),
    company_logradouro : new FormControl<string>('',Validators.required),
    company_numero : new FormControl<string>('',Validators.required),
    company_complemento : new FormControl<string>(''),
    company_cep : new FormControl<string>('',Validators.required),
    company_bairro : new FormControl<string>('',Validators.required),
    company_cidade : new FormControl<string>('',Validators.required),
    company_estado : new FormControl<string>('',Validators.required),
    sponsor_cpf : new FormControl<string>('',Validators.required),
    sponsor_name : new FormControl<string>('',Validators.required),
    sponsor_email : new FormControl<string>('',Validators.required),
    sponsor_phone : new FormControl<string>('',Validators.required),
    splitsDeposito: new FormArray([
      new FormGroup({
        accountId : new FormControl<string>(''),
        taxValue : new FormControl<number>(0),
        taxPercent : new FormControl<number>(0),
        scope : new FormControl<string>('')
      })
    ]),
    splitsWithDraw: new FormArray([
      new FormGroup({
        accountId : new FormControl<string>(''),
        taxValue : new FormControl<number>(0),
        taxPercent : new FormControl<number>(0),
        scope : new FormControl<string>('')
      })
    ]),
    splitsCripto: new FormArray([
      new FormGroup({
        accountId : new FormControl<string>(''),
        taxValue : new FormControl<number>(0),
        taxPercent : new FormControl<number>(0),
        scope : new FormControl<string>('')
      })
    ])
  });

  public accounts: any[];
  public scopes = [{name: 'Aplicativo', value: 'WEB' }, {name: 'API', value: 'API' }, {name: 'TEF', value: 'TEF' } ];
  public personTypes = [{name: 'Jurídica', value: '0' }, {name: 'Física', value: '1' }];

  constructor(private accountService : AccountService,
              private toastr: ToastrService,
              private fb: FormBuilder) {
    this.accounts = [];
    this.getAccounts();
  }

  getAccounts(){
    this.accountService.getAccounts().subscribe(
      value => {
        this.accounts = value;
      }
    );
  }

  addSplitDeposito(){
    const control = <FormArray>this.account.controls['splitsDeposito'];
    control.push(this.fb.group(
      {
        accountId : new FormControl<string>(''),
        taxValue : new FormControl<number>(0),
        taxPercent : new FormControl<number>(0),
        scope : new FormControl<string>('')
      }));
  }

  addSplitWithDraw(){
    const control = <FormArray>this.account.controls['splitsWithDraw'];
    control.push(this.fb.group(
      {
        accountId : new FormControl<string>(''),
        taxValue : new FormControl<number>(0),
        taxPercent : new FormControl<number>(0),
        scope : new FormControl<string>('')
      }));
  }

  addSplitCripto(){
    const control = <FormArray>this.account.controls['splitsCripto'];
    control.push(this.fb.group(
      {
        accountId : new FormControl<string>(''),
        taxValue : new FormControl<number>(0),
        taxPercent : new FormControl<number>(0),
        scope : new FormControl<string>('')
      }));
  }

  accountGetSplit($event: Event) {
    // @ts-ignore
    this.getSplits = $event.target.checked;
  }

  save(){
    this.isSubmitted = true;

    if(this.account.controls.personType.value == 1)
    {
      this.account.controls.company_cnpj.setErrors(null);
      this.account.controls.company_razaoSocial.setErrors(null);
      this.account.controls.company_email.setErrors(null);
      this.account.controls.company_phone.setErrors(null);
    }

    if(this.account.valid){
      let account= this.account.controls.personType.value == 0 ?
      {
        description: this.account.get('description')?.value,
        personType: Number(this.account.get('personType')?.value),
        getSplit: this.getSplits,
        company:
          {
            cnpj: this.account.get('company_cnpj')?.value,
            razaoSocial: this.account.get('company_razaoSocial')?.value,
            email: this.account.get('company_email')?.value,
            phone: this.account.get('company_phone')?.value
          },
        adress:
          {
            logradouro: this.account.get('company_logradouro')?.value,
            numero: this.account.get('company_numero')?.value,
            complemento: this.account.get('company_complemento')?.value,
            cep: this.account.get('company_cep')?.value,
            bairro: this.account.get('company_bairro')?.value,
            cidade: this.account.get('company_cidade')?.value,
            estado: this.account.get('company_estado')?.value
          },
        sponsor:
          {
            cpf: this.account.get('sponsor_cpf')?.value,
            name: this.account.get('sponsor_name')?.value,
            email: this.account.get('sponsor_email')?.value,
            phone: this.account.get('sponsor_phone')?.value
          },
        depositConfiguration:{
          bankProviderId: "96b5cda4-2f05-4808-9c53-116019cc7695",
          splitConfigurations: this.account.controls.splitsDeposito.controls.map(function(fg){
            return {
              accountId: fg.controls.accountId.value,
              taxValue: fg.controls.taxValue.value,
              taxPercent: fg.controls.taxPercent.value,
              scope: fg.controls.scope.value
            };
          })
        },
        withDrawConfiguration:{
          bankProviderId: "96b5cda4-2f05-4808-9c53-116019cc7695",
          splitConfigurations: this.account.controls.splitsWithDraw.controls.map(function(fg){
            return {
              accountId: fg.controls.accountId.value,
              taxValue: fg.controls.taxValue.value,
              taxPercent: fg.controls.taxPercent.value,
              scope: fg.controls.scope.value
            };
          })
        },
        cryptoConfiguration:{
          bankProviderId: "96b5cda4-2f05-4808-9c53-116019cc7695",
          splitConfigurations: this.account.controls.splitsCripto.controls.map(function(fg){
            return {
              accountId: fg.controls.accountId.value,
              taxValue: fg.controls.taxValue.value,
              taxPercent: fg.controls.taxPercent.value,
              scope: fg.controls.scope.value
            };
          })
        }
      } :
        {
          description: this.account.get('description')?.value,
          personType: Number(this.account.get('personType')?.value),
          getSplit: this.getSplits,
          adress:
            {
              logradouro: this.account.get('company_logradouro')?.value,
              numero: this.account.get('company_numero')?.value,
              complemento: this.account.get('company_complemento')?.value,
              cep: this.account.get('company_cep')?.value,
              bairro: this.account.get('company_bairro')?.value,
              cidade: this.account.get('company_cidade')?.value,
              estado: this.account.get('company_estado')?.value
            },
          sponsor:
            {
              cpf: this.account.get('sponsor_cpf')?.value,
              name: this.account.get('sponsor_name')?.value,
              email: this.account.get('sponsor_email')?.value,
              phone: this.account.get('sponsor_phone')?.value
            },
          depositConfiguration:{
            bankProviderId: "96b5cda4-2f05-4808-9c53-116019cc7695",
            splitConfigurations: this.account.controls.splitsDeposito.controls.map(function(fg){
              return {
                accountId: fg.controls.accountId.value,
                taxValue: fg.controls.taxValue.value,
                taxPercent: fg.controls.taxPercent.value,
                scope: fg.controls.scope.value
              };
            })
          },
          withDrawConfiguration:{
            bankProviderId: "96b5cda4-2f05-4808-9c53-116019cc7695",
            splitConfigurations: this.account.controls.splitsWithDraw.controls.map(function(fg){
              return {
                accountId: fg.controls.accountId.value,
                taxValue: fg.controls.taxValue.value,
                taxPercent: fg.controls.taxPercent.value,
                scope: fg.controls.scope.value
              };
            })
          },
          cryptoConfiguration:{
            bankProviderId: "96b5cda4-2f05-4808-9c53-116019cc7695",
            splitConfigurations: this.account.controls.splitsCripto.controls.map(function(fg){
              return {
                accountId: fg.controls.accountId.value,
                taxValue: fg.controls.taxValue.value,
                taxPercent: fg.controls.taxPercent.value,
                scope: fg.controls.scope.value
              };
            })
          }
        }
      this.accountService.insertAccount(account).subscribe(
        next =>{
          this.toastr.success(`Conta criada com sucesso! Conta: ${next.id}`,'Sucesso',{
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          this.account.reset();
        },
        error =>{
          this.toastr.error(error.error.mensagem,'Erro',{
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
        }
      );
      this.isSubmitted = false;
    }
  }
}
